import { autoinject } from 'aurelia-framework';
import { HPFServiceClient } from './hpfApi';
import { HttpClient } from 'aurelia-fetch-client';
import { State } from './global-state';
import { ApiResponse } from '../models/api-response';
import { ServiceResponse } from '../models/service-response';
import { CheckPaymentMethod } from './hpf-transaction-service';

@autoinject
export class HpfPaymentMethodService extends HPFServiceClient {
	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	verifyCheckAccepted(customerKey: number, paymentMethod: CheckPaymentMethod, userType: string): Promise<ServiceResponse> {
		let requestBody: any;
		requestBody = ({
			customerKey,
			check: paymentMethod,
			userType
		} as IVerifyCheckAcceptedRequest);

		return this.post(
			`/customer/${customerKey}/paymentmethods/check/verification`,
			requestBody)
			.then((response: ApiResponse) => {
				if (!response.isSuccessful) {
					let errorMessage = response.errors.length > 0 ?
						response.errors[0] :
						'Unable to verify bank account';
					return this.error(`${errorMessage}`);
				}
				return this.success();
			});
	}
}

export interface IVerifyCheckAcceptedRequest {
	customerKey: number;
	check: CheckPaymentMethod;
	userType: string;
}